import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Login.css';

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErr('');
    setLoading(true);
    try {
      const res = await fetch('/api/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim().toLowerCase() }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        setErr(data.error || 'Something went wrong');
        return;
      }
      setSubmitted(true);
    } catch (e: any) {
      setErr(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h1>Cafe Ops Manager</h1>
        <h2>Reset password</h2>

        {submitted ? (
          <div>
            <p>If an account with that email exists, we've sent a reset link. Check your inbox (and spam folder) — the link is good for 1 hour.</p>
            <p style={{ marginTop: '1rem' }}>
              <Link to="/login">← Back to sign in</Link>
            </p>
          </div>
        ) : (
          <form onSubmit={submit}>
            <p style={{ color: '#555', marginBottom: '1rem' }}>
              Enter your email and we'll send you a link to set a new password.
            </p>
            {err && <div className="error-message">{err}</div>}
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value.trim())}
                required
                autoComplete="email"
                placeholder="name@chai-social.ca"
                disabled={loading}
              />
            </div>
            <button type="submit" className="login-button" disabled={loading || !email}>
              {loading ? 'Sending…' : 'Send reset link'}
            </button>
            <p style={{ marginTop: '1rem', textAlign: 'center' }}>
              <Link to="/login">← Back to sign in</Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
